import { DemoDataBanner, MultiLocationLargeModeOnlyFeature } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { Page } from '@frontend/page';
import { CallAnalyticsPanel } from '../components/call-analytics-panel';
import { PhoneAnalyticsFilters } from '../components/filters/phone-analytics-filters';
import { breadcrumbsBase, DEFAULT_ACTIVE_TAB_VIEW, defaultBarChartAppearance } from '../constants';
import { useOnPhoneAnalyticsPageLoad } from '../hooks/use-on-phone-analytics-page-load';
import { actionLessPageHeadingSmallMode } from '../shared-styles';

export const CallVolumeAnalytics = () => {
  const { t } = useTranslation('analytics-phone');
  const { filters, isDemoAccount, pageSubtitle } = useOnPhoneAnalyticsPageLoad();

  return (
    <>
      {isDemoAccount && (
        <DemoDataBanner title={t("You're taking Call Volume Analytics for a test drive with demo data!")} />
      )}
      <Page>
        <Page.Header>
          <Page.Header.Breadcrumbs breadcrumbs={[...breadcrumbsBase, { label: t('Call Volume Analytics') }]} />
          <Page.Header.Heading css={actionLessPageHeadingSmallMode}>
            <Page.Header.Title title={t('Call Volume Analytics')} />
            <Page.Header.Subtitle
              subtitle={t('Showing results for {{filtersInfo}}', {
                filtersInfo: pageSubtitle,
              })}
            />
          </Page.Header.Heading>
        </Page.Header>

        <Page.Body>
          <PhoneAnalyticsFilters activeTab={DEFAULT_ACTIVE_TAB_VIEW} />
          <CallAnalyticsPanel defaultChartAppearance={defaultBarChartAppearance} />
        </Page.Body>
      </Page>
      <MultiLocationLargeModeOnlyFeature locationCount={filters.location_id?.length} />
    </>
  );
};
